<script setup>
import PublicLayout from "@/Layouts/Guest.vue";
import InterpretCardHorizontal from "@/Components/InterpretCardHorizontal.vue";
import Breadcrumb from "@/Components/Breadcrumb.vue";
import Pagination from "@/Components/Pagination.vue";
import AdsenceModule from "@/Modules/Adsence.vue";
import NovaAlbaModule from "@/Modules/NovaAlba.vue";
import NavLink from '@/Components/NavLink.vue';

import { ref, watch, computed } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link } from "@inertiajs/inertia-vue3";
import debounce from "lodash/debounce";

const props = defineProps( {
    items: Object,
    od: String,
    newAlbums: Object,
    filters: Object,
});

const az = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const azLower = "abcdefghijklmnopqrstuvwxyz".split("");
let search = ref(props.filters.search);

watch(search, debounce(function(value) {
    Inertia.get('/', { search: value }, { preserveState: true, replace: true });
    // console.log(value);
}, 300));

</script>

<template>
  <Head>
    <title>Diskografie.cz</title>
    <meta head-key="description" name="description" content="Diskografie.cz - přehled vydaných alb, písní, videa." />
    <meta head-key="keywords" name="keywords" content="diskografie, alba, texty písní, videa" />
    <meta head-key="tw_title" name="twitter:title" content="Diskografie.cz"/>
    <meta head-key="tw_description" name="twitter:description" content="Diskografie.cz - přehled vydaných alb, písní, videa."/>
    <meta head-key="og_site_name" property="og:site_name" content="Diskografie.cz"/>
    <meta head-key="og_title" property="og:title" content="Diskografie.cz"/>
    <meta head-key="og_url" property="og:url" content="https://diskografie.cz"/>
    <meta head-key="og_description" property="og:description" content="Diskografie.cz - přehled vydaných alb, písní, videa."/>
    <meta head-key="og_image" property="og:image" content="/images/logo.svg">    
    <meta head-key="og_type" property="og:type" content="article"/>
    <meta head-key="og_locale" property="og:locale" content="cs_cz"/>    
  </Head>

  <Breadcrumb :items="[]" />
  <div class="row">
    <div class="col-12 col-lg-8 px-0">
        <div class="bg-white p-3 border rounded-3 mb-1 mb-lg-0 me-lg-1">
            <h2 class="main-title">{{ $t('Diskografie') }}</h2>
            <p>{{ $t('Procházejte diskografii umělců od A do Z nebo mrkněte na novinky.') }}</p>
            <div class="py-3">

                <div class="d-flex align-items-start">
                    <ul class="nav flex-column nav-tabs left-tabs me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <Link :href="'/'"><li class="nav-link" :class="{ active: (od == '') }">Index</li></Link>
                        <Link :href="'/index/0-9'"><li class="nav-link" :class="{ active: (od == '0-9') }">0-9</li></Link>
                        <template v-for="(value, index) in az" :key="index">
                            <Link :href="'/index/'+ azLower[index]"><li class="nav-link" :class="{ active: (od == azLower[index]) }">{{ value }}</li></Link>
                        </template>
                    </ul>

                    <div class="w-100">
                        <template v-if="od === ''">
                            <h3 class='text-center'>Hledat umělce</h3>
                            <input v-model="search" class="form-control form-control-lg mb-4" type="text" placeholder="Hledej">
                            <h3 v-if="!filters.search" class='text-center'>Nově přidaní umělci</h3>
                        </template>    
                        <div class="row row-cols-1 row-cols-lg-2 g-1">    
                            <div class="col" v-for="item in items.data" :key="item.alias">
                                <InterpretCardHorizontal :item="item" />  
                            </div> 
                        </div>
                        <Pagination v-if="od !== ''" :links="items.links" />
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="col-12 col-lg-4 px-0">
        
        <div class="bg-white p-3 mb-1 border rounded-3">
            <h3 class="text-secondary">Nová alba</h3>
            <NovaAlbaModule :items="newAlbums.data" />
        </div>

        <div class="bg-white p-1 mb-0 border rounded-3">
            <AdsenceModule />
        </div>

    </div>
  </div>
</template>
